import {Component, OnInit} from '@angular/core';
import {RouterPathService} from '../../../../core/common/variables/router-path.service';
import {ImagePathService} from '../../../../core/common/variables/image-path.service';
import {TranslateService} from '../../../common/variables/translate-service';
import {GlobalVariableService} from '../../../common/variables/global-variable';
import {GlobalService} from '../../../common/services/global.service';
import {GlobalFunctionService} from '../../../common/services/global-function.service';
import {
    FormBuilder,
    FormGroup,
    FormArray,
    FormControl
} from '@angular/forms';
import {ISlimScrollOptions, SlimScrollEvent} from 'ngx-slimscroll';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs';
import {cloneDeep} from 'lodash';
import {SC_Input} from '../../../common/input/SC_Input';
import {
    clearSelectProject,
    copyProject,
    clearAllProjects,
    removeProject,
    planModified,
    addSelectedPlan,
    clearSelectedPlan,
    selectedInverterEdit,
    clearInverterEdit,
    addKWToProject,
    selectProject,
    selectProjectSuccess
} from '../../../store/senAppProjects.action';
import {ProjectGetData, ProjectGetInverterPlan, ProjectGetRoofPlan} from '../../../common/api/ProjectGet';
import {RoofPlanCopyInput, RoofPlanCopyOutput} from '../../../common/api/RoofPlanCopy';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {RoofParameterService} from '../../../common/roof/roof-parameter.service';
import InverterModel from '../../../common/lib/InverterModel';
import {clearDataOnExit} from '../../../common/panel/clearDataOnExit';
import {Global} from '../../../common/utilities/global';
import * as _ from 'lodash';
import {Actions, ofType} from '@ngrx/effects';
import {OutputBase} from '../../../common/api/common/OutputBase';
import {InverterPlanGetData, InverterPlanGetInput, InverterPlanGetOutput} from '../../../common/api/InverterPlanGet';
import {PanelGetData, PanelGetOutput} from '../../../common/api/PanelGet';
import {InputBoxEmit} from '../../../common/lib/InputBoxData';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'sen-app-project',
    templateUrl: './project.component.html',
    styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit {

    createProjectPath: string;
    roofPlanPath: string;
    inverterSearchPath: string;
    inverterCusPath: string;
    form: FormGroup;
    selectedRoofPlansArray: number[];
    selectedInverterPlansArray: number[];
    selectedProject$: Observable<ProjectGetData>;
    selectedProjectArray: ProjectGetData;
    selectedRoofPlan: ProjectGetRoofPlan | null;
    triggerPanelUnsubscribe: Subscription;
    globalFPanelUnsubscribe: Subscription;
    unsubscribeSelectedProject: Subscription;
    sPanel: PanelGetData;
    projectModulname: string;

    constructor(private routerPath: RouterPathService,
                public imagePath: ImagePathService,
                private roofParams: RoofParameterService,
                private _snackBar: MatSnackBar,
                public translate: TranslateService,
                public global: GlobalVariableService,
                public globalService: GlobalService,
                public globalF: GlobalFunctionService,
                private formBuilder: FormBuilder,
                private router: Router,
                private action: Actions,
                public dialog: MatDialog,
                private store: Store<any>) {

        this.createProjectPath = this.routerPath.createProjcetPath;
        this.roofPlanPath = this.routerPath.RPMountingPath;
        this.inverterSearchPath = this.routerPath.IPSearchInverterPath;
        this.inverterCusPath = `${this.routerPath.inverterPlanPath}${this.routerPath.pathSeperator}${this.routerPath.IPCustomizeString}`;
        this.selectedProject$ = this.store.select(state => {
            return state.appData.selectedProject;
        });
        this.unsubscribeSelectedProject = this.selectedProject$.subscribe((data: any) => {
            if (data) {
                this.selectedRoofPlan = null;
                this.selectedProjectArray = cloneDeep(data);
                this.globalF.setProjectMetadata(this.selectedProjectArray);
            }
            try {
                this.selectedProjectArray.updated = SC_Input.sProject.selectedProject.updated;
            } catch {
            }
        });
        //when ever project selected its corresponding panel triggered
        this.triggerPanelUnsubscribe = this.action.pipe(ofType(selectProjectSuccess)).subscribe(() => {
            if (this.selectedProjectArray.panelID) {
                this.getPanel(this.selectedProjectArray.panelID);
            } else {
                this.projectModulname = SC_Input.projectModulname = '';
            }
        });
    }

    initiateForm() {
        this.form = this.formBuilder.group({
            plans: new FormArray([]),
            inverters: new FormArray([])
        });
    }

    ngOnInit(): void {
        SC_Input.sPlan = null;
        SC_Input.sInverter = new InverterPlanGetData();
        this.store.dispatch(clearSelectedPlan());
        this.store.dispatch(clearInverterEdit());
        if (this.selectedProjectArray?.panelID) {
            this.getPanel(this.selectedProjectArray.panelID);
        } else {
            SC_Input.reset();
        }
    }

    ngOnDestroy() {
        if (this.triggerPanelUnsubscribe) {
            this.triggerPanelUnsubscribe.unsubscribe();
        }
        if (this.globalFPanelUnsubscribe) {
            this.globalFPanelUnsubscribe.unsubscribe();
        }
        if (this.unsubscribeSelectedProject) {
            this.unsubscribeSelectedProject.unsubscribe();
        }
    }

    setSelectedRoofPlan(plan: ProjectGetRoofPlan) {
        setTimeout(() => {
            if (this.selectedRoofPlan && plan.id == this.selectedRoofPlan.id) {
                this.selectedRoofPlan = null;
            } else {
                this.selectedRoofPlan = plan;
            }
        }, 100);
    }

    get plansFormArray() {
        return this.form.controls.plans as FormArray;
    }

    get invertersFormArray() {
        return this.form.controls.inverters as FormArray;
    }

    deletePlan() {
        let dialogRef = this.globalF.openConfirmationBox('DELETE_PLAN_QUE', 'REMOVE', 'CANCEL');
        dialogRef.afterClosed().subscribe((result: boolean) => {
            dialogRef.close();
            if (result) {
                const qParam = {
                    cmd: this.global.RoofPlanRemove,
                    id: this.selectedRoofPlan?.id
                };
                this.globalService.getData(qParam).subscribe((data: OutputBase) => {
                    if (data && data.ok) {
                        this.store.dispatch(clearSelectProject());
                        this.store.dispatch(planModified());
                    }
                });
            }
        });
    }

    copyPlan() {
        let dialogRef = this.globalF.openInputBox(`${this.translate.getLng('PLAN')} ${this.translate.getLng('NAME')}`);
        dialogRef.afterClosed().subscribe((result: InputBoxEmit) => {
            if (result.action) {
                const qParam: RoofPlanCopyInput = {
                    cmd: this.global.RoofPlanCopy,
                    id: this.selectedRoofPlan?.id || NaN,
                    name: result.name,
                    projectID: SC_Input.sProject.selectedProject.id
                };
                this.globalService.getData(qParam).subscribe((data: RoofPlanCopyOutput) => {
                    if (data && data.ok) {
                        dialogRef.close();
                        this.store.dispatch(clearSelectProject());
                        this.store.dispatch(planModified());
                    }
                });
            }
        });
    }

    editProject() {
        this.router.navigate([this.createProjectPath], {queryParams: {action: this.global.editProject}});
    }

    copyProject() {
        let dialogRef = this.globalF.openInputBox(this.translate.getLng('PROJECT_NAME'));
        dialogRef.afterClosed().subscribe((result: InputBoxEmit) => {
            if (result.action) {
                const qParam = {
                    cmd: this.global.projectCopy,
                    id: SC_Input.sProject.selectedProject.id,
                    name: result.name
                };
                this.globalService.getData(qParam).subscribe((data: OutputBase) => {
                    if (data && data.ok) {
                        dialogRef.close();
                        this.store.dispatch(clearAllProjects());
                        this.store.dispatch(copyProject());
                    } else if (data.error?.code == this.global.nameCollision) {
                        this._snackBar.open(data.error?.message || '');
                        setTimeout(() => {
                            this.copyProject();
                        }, 3000);
                    }
                });
            }
        });
    }

    deleteProject() {
        let dialogRef = this.globalF.openConfirmationBox('DELETE_PROJECT_QUE', 'REMOVE', 'CANCEL');
        dialogRef.afterClosed().subscribe((result: boolean) => {
            dialogRef.close();
            if (result) {
                const qParam = {
                    cmd: this.global.projectRemove,
                    id: SC_Input.sProject.selectedProject.id
                };
                this.globalService.getData(qParam).subscribe((data: OutputBase) => {
                    if (data && data.ok) {
                        this.global.selectedProject = null;
                        this.store.dispatch(clearSelectProject());
                        this.store.dispatch(removeProject());
                    }
                });
            }
        });
    }

    getPanel(pID: number, reqPanel?: Boolean) {
        this.globalFPanelUnsubscribe = this.globalF.getPanelDetail(pID).subscribe((data: PanelGetOutput) => {
            try {
                if (data.ok.data) {
                    data.ok.data.id = pID;
                    SC_Input.reset();
                    this.globalF.setPanel(data.ok.data);
                    this.sPanel = data.ok.data;
                    if (this.selectedProjectArray.panelID == pID) {
                        this.projectModulname = SC_Input.projectModulname = this.sPanel.name;
                    }
                    this.addTotalKW(this.selectedProjectArray, data.ok.data.Pdc);
                    if (reqPanel) {
                        this.roofParams.getRoofParams();
                    }
                    clearDataOnExit();
                }
            } catch {
            }
        });
    }

    addTotalKW(project: ProjectGetData, pdc: number) {
        if (project.roofPlans.length) {
            let totalKW = 0;
            project.roofPlans.forEach((p: ProjectGetRoofPlan) => {
                if (p.panelID == this.selectedProjectArray.panelID) {
                    totalKW += Global.getKW(p.panelCount, pdc);
                }
            });
            project.totalKW = totalKW;
            this.store.dispatch(addKWToProject(project));
        }
    }

    checkAllPlansValid() {
        if (this.selectedProjectArray.roofPlans.length) {
            let f = this.selectedProjectArray.roofPlans.filter((p: ProjectGetRoofPlan) => !p.invalid);
            return f.length > 0;
        } else {
            return false;
        }
    }

    setPanelCount() {
        SC_Input.sInverter.panelCount = 0;
        this.selectedProjectArray.roofPlans.forEach((p: ProjectGetRoofPlan) => {
            if (this.selectedProjectArray.panelID == p.panelID) {
                SC_Input.sInverter.panelCount += p.panelCount;
            }
        });
    }

    addInverter() {
        this.setPanelCount();
        this.navigateToInvSearchPath(this.inverterSearchPath);
    }

    navigateToInvSearchPath(path: string) {
        if (this.selectedProjectArray.roofPlans.length && SC_Input.sInverter.panelCount) {
            this.router.navigate([path]);
        } else {
            this._snackBar.open(this.translate.getLng('NO_MATCH_PANEL'));
        }
    }

    getInverter() {
        const qParam: InverterPlanGetInput = {
            cmd: this.global.InverterPlanGet,
            id: this.selectedProjectArray.inverterPlan.id
        };
        this.globalService.getData(qParam).subscribe((data: InverterPlanGetOutput) => {
            try {
                if (data && data.ok) {
                    data.ok.data.id = this.selectedProjectArray.inverterPlan.id;
                    SC_Input.sInverter = data.ok.data;
                    this.setPanelCount();
                    this.store.dispatch(selectedInverterEdit(data.ok.data));
                    if (data.ok.data.subGenerators.length) {
                        this.router.navigate([this.inverterCusPath]);
                    } else {
                        this.navigateToInvSearchPath(this.inverterSearchPath);
                    }
                }
            } catch {
            }
        });
    }

    getPlanParams(roofPlanInfo: ProjectGetRoofPlan) {
        SC_Input.sPlan = roofPlanInfo;
        this.store.dispatch(addSelectedPlan(roofPlanInfo));
        if (roofPlanInfo.panelID != this.selectedProjectArray.panelID) {
            this.getPanel(roofPlanInfo.panelID, true);
        } else {
            this.roofParams.getRoofParams();
        }
    }

    newPlanCreation() {
        Global.toggleBoundaryArea = false;
        this.navNext();
    }

    navNext() {
        clearDataOnExit();
        SC_Input.sPlan = null;
        this.store.dispatch(clearSelectedPlan());
        this.router.navigate([this.roofPlanPath]);
    }

    exportRoofPlan(roofPlanInfo: ProjectGetRoofPlan) {
        let id = roofPlanInfo.id;
        const qParam = {
            cmd: "RoofPlanExport",
            roofPlanID: roofPlanInfo.id,
        };
        this.globalService.getData(qParam).subscribe((data: any) => {
            if (data && data.ok) {
                if (data.ok.message) {
                    this._snackBar.open(data.ok.message);
                }
            } else {
                this._snackBar.open(data.error?.message || '');
            }
        });
    }
}
